<template>
  <ui-hover-card :open-delay="100" :close-delay="100">
    <ui-hover-card-trigger as-child>
      <button
        type="button"
        data-slot="info-popup"
        class="inline-flex shrink-0 cursor-help items-center align-middle text-primary"
        :aria-label="tr('More info')"
        @click.prevent
      >
        <info-icon class="size-4" />
      </button>
    </ui-hover-card-trigger>
    <ui-hover-card-content class="w-72 text-sm leading-relaxed [&_li]:ml-4 [&_ul]:my-1 [&_ul]:list-disc">
      <slot />
    </ui-hover-card-content>
  </ui-hover-card>
</template>

<script>
import { Info } from '@lucide/vue';

/** Info icon that shows its slot content on hover (and on focus). */
export default {
  name: 'InfoPopup',
  components: {
    InfoIcon: Info,
  },
};
</script>
